// import React, { useEffect, useState, useCallback } from "react";
// import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MainLayout from "./components/mainscreen/mainlayout"; // Import the new layout component
import MainScreen from "./components/mainscreen/mainscreen";
import Login from "./components/login/login";
import UserFeedback from "./components/login/userfeedback";
import UserComplain from "./components/login/usercomplain";
import Signup from "./components/login/signup";
import axios from "axios";
import SendMail from "./components/login/sendmail";
import ForgetPassword from "./components/login/forgetpassword";
import Float from "./components/login/float"; // Import the Float component
import Settings from "./components/settings/settingsmain"; // Import the Float component
import { ToastProvider } from "./components/login/float"; // Import the ToastProvider
import { LanguageProvider } from "./components/login/LanguageContext"; // Import the provider
import "@fontsource/poppins"; // Defaults to weight 400
import ManajemenPengguna from "./components/mainscreen/manajemenpengguna.js/manajemenpenggunascreen";
import InputData from "./components/mainscreen/inputdata/inputdatascreen";
import IngredientsTable from "./components/mainscreen/inputdata/getdata";
import DapurTable from "./components/mainscreen/manajemenpengguna.js/manajemendapur";
import LocationTable from "./components/mainscreen/manajemenpengguna.js/manajemenlocation";
import PriceUploadTable from "./components/mainscreen/manajemenpengguna.js/manajemenuploadharga";
import InputDapur from "./components/mainscreen/inputdata/inputdapurscreen";
import InputLocation from "./components/mainscreen/inputdata/inputlocationscreen";
import DaftarPemasok from "./components/mainscreen/daftarpemasok/daftarpemasokscreen";
import MenuMingguan from "./components/mainscreen/menumingguan/dragndrop";
import DaftarMenuMingguan from "./components/mainscreen/menumingguan/daftarmenumingguan";
import PesananScreen from "./components/mainscreen/pesananscreen/pesananscreen";
import MenuHarianScreen from "./components/menuharian/menuharianscreen";
import InputRecipes from "./components/mainscreen/inputdata/menu";
import PenerimaanBahan from "./components/mainscreen/penerimaanbahan";
import PenerimaanPO from "./components/mainscreen/pesananscreen/penerimaanPO";
import OrdersTable from "./components/mainscreen/pesananscreen/pemesananpesanan";
import DaftarPO from "./components/mainscreen/pesananscreen/daftarPO";
import DaftarDO from "./components/mainscreen/pesananscreen/daftarDO";
import DaftarStock from "./components/mainscreen/pesananscreen/daftarStock";
import DaftarStockDapur from "./components/mainscreen/pesananscreen/daftarStockDapur";
import CsvPage from "./components/mainscreen/inputdata/uploadharga";
import UploadResep from "./components/mainscreen/inputdata/uploadresep";
import PenerimaanBahanDapur from "./components/mainscreen/penerimaanbahandapur";
// import UploadTable from "./components/mainscreen/inputdata/detailuploadtable";
import PenerimaanBahanSortByDapur from "./components/mainscreen/penerimaanbahansortbydapur";
import TabelLaporanProduksi from "./components/mainscreen/tabellaporanproduksi";
import JadwalCustomer from "./components/mainscreen/jadwalcustomer";
import TabelJadwalCustomer from "./components/mainscreen/tabeljadwalcustomer";
import PriceUploadTableDetail from "./components/mainscreen/manajemenpengguna.js/manajemenuploadhargadetail";
import TambahPemasok from "./components/mainscreen/daftarpemasok/tambahpemasok";
import EditPemasok from "./components/mainscreen/daftarpemasok/editpemasok";
import LihatPemasok from "./components/mainscreen/daftarpemasok/lihatpemasok";
import TambahMenu from "./components/mainscreen/inputdata/tambahmenu";
import DraftOrder from "./components/mainscreen/pesananscreen/daftarpesanan";
import DaftarHariLibur from "./components/mainscreen/daftarharilibur";
import TambahHariLibur from "./components/mainscreen/tambahharilibur";
import PenerimaanDO from "./components/mainscreen/penerimaanDO";
import TambahDapur from "./components/mainscreen/inputdata/tambahdapur";
import TambahHasilProduksi from "./components/mainscreen/tambahhasilproduksi";
import DaftarKonsumen from "./components/mainscreen/inputdata/konsumen";
import TambahKonsumen from "./components/mainscreen/inputdata/tambahkonsumen";
import WeeklyReport from "./components/mainscreen/weeklyreport";
import WeeklyReport2 from "./components/mainscreen/weeklyreport2";
import MonthlyReport from "./components/mainscreen/monthlyreport";
import DailyReport from "./components/mainscreen/dailyreport";
import OrderTambahan from "./components/mainscreen/ordertambahan";
import TabelFeedbackCustomer from "./components/mainscreen/dashboard.js/tabelfeedbackcustomer";
import TabelFeedbackSupplier from "./components/mainscreen/dashboard.js/ratingsupplier";
import IngredientsCategoryTable from "./components/mainscreen/inputdata/daftarkategoribahanbaku";
import DetailProduksiHarian from "./components/mainscreen/detailproduksiharian";
import { Toaster } from "./components/shadcn/sonner";

function App() {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  axios.interceptors.request.use((config) => {
    const token = localStorage?.getItem("ACCESS") || null;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return (
    <QueryClientProvider client={client}>
      <Toaster closeButton richColors theme="light" />
      <ToastProvider>
        <Float />
        <LanguageProvider>
          <Router>
            <Routes>
              {/* Route without Sidebar */}
              <Route path="/userfeedback" element={<UserFeedback />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/sendmail" element={<SendMail />} />
              <Route path="/usercomplain" element={<UserComplain />} />

              {/* Routes with Sidebar */}
              <Route element={<MainLayout />}>
                <Route path="/" element={<MainScreen />} />
                <Route path="/inputdata" element={<InputData />} />
                <Route path="/inputlocation" element={<InputLocation />} />
                <Route path="/inputdapur" element={<InputDapur />} />
                <Route path="/tambahdapur" element={<TambahDapur />} />
                <Route path="/inputmenu" element={<InputRecipes />} />
                <Route path="/tambahmenu" element={<TambahMenu />} />
                <Route path="/menumingguan" element={<MenuMingguan />} />
                <Route path="/menuharian" element={<MenuHarianScreen />} />
                <Route
                  path="/ingredientstable"
                  element={<IngredientsTable />}
                />
                <Route
                  path="/ingredientscategorytable"
                  element={<IngredientsCategoryTable />}
                />
                <Route path="/dapurtable" element={<DapurTable />} />
                <Route path="/locationtable" element={<LocationTable />} />
                <Route path="/daftarpemasok" element={<DaftarPemasok />} />
                <Route path="/tambahpemasok" element={<TambahPemasok />} />
                <Route path="/editpemasok" element={<EditPemasok />} />
                <Route path="/lihatpemasok" element={<LihatPemasok />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/penerimaanbahan" element={<PenerimaanBahan />} />
                <Route
                  path="/penerimaanbahandapur"
                  element={<PenerimaanBahanDapur />}
                />
                <Route
                  path="/penerimaanbahansortbydapur"
                  element={<PenerimaanBahanSortByDapur />}
                />
                <Route path="/penerimaanPO" element={<PenerimaanPO />} />
                <Route
                  path="/manajemenpengguna"
                  element={<ManajemenPengguna />}
                />
                <Route
                  path="/manajemenuploadharga"
                  element={<PriceUploadTable />}
                />
                <Route
                  path="/manajemenuploadhargadetail"
                  element={<PriceUploadTableDetail />}
                />
                {/* <Route path="/detailuploadtable" element={<UploadTable />} /> */}
                <Route path="/daftarpesanan" element={<PesananScreen />} />
                <Route
                  path="/daftarmenumingguan"
                  element={<DaftarMenuMingguan />}
                />
                <Route path="/daftarpemesanan" element={<OrdersTable />} />
                <Route path="/daftarPO" element={<DaftarPO />} />
                <Route path="/uploadharga" element={<CsvPage />} />
                <Route path="/uploadresep" element={<UploadResep />} />
                <Route
                  path="/tabellaporanproduksi"
                  element={<TabelLaporanProduksi dashboard={false}/>}
                />
                <Route
                  path="/tambahhasilproduksi"
                  element={<TambahHasilProduksi />}
                />
                <Route path="/jadwalcustomer" element={<JadwalCustomer />} />
                <Route
                  path="/tabeljadwalcustomer"
                  element={<TabelJadwalCustomer />}
                />
                <Route
                  path="/detailproduksiharian"
                  element={<DetailProduksiHarian />}
                />
                <Route path="/draftOrder" element={<DraftOrder />} />
                <Route path="/daftarharilibur" element={<DaftarHariLibur />} />
                <Route path="/tambahharilibur" element={<TambahHariLibur />} />
                <Route path="/editharilibur" element={<TambahHariLibur />} />
                <Route path="/penerimaanDO" element={<PenerimaanDO />} />
                <Route path="/daftarDO" element={<DaftarDO />} />
                <Route path="/daftarStock" element={<DaftarStock tombol={false} />} />
                <Route
                  path="/daftarStockDapur"
                  element={<DaftarStockDapur />}
                />
                <Route path="/userfeedback" element={<UserFeedback />} />
                <Route path="/usercomplain" element={<UserComplain />} />
                <Route path="/daftarkonsumen" element={<DaftarKonsumen />} />
                <Route path="/tambahkonsumen" element={<TambahKonsumen />} />
                <Route path="/weeklyreport" element={<WeeklyReport />} />
                <Route path="/weeklyreports" element={<WeeklyReport2 />} />
                <Route path="/monthlyreport" element={<MonthlyReport />} />
                <Route path="/dailyreport" element={<DailyReport />} />
                <Route path="/ratingpelanggan" element={<TabelFeedbackCustomer tombol={false} jumlahdata={10} />} />
                <Route path="/ratingsupplier" element={<TabelFeedbackSupplier tombol={false} jumlahdata={10} />} />
                <Route path="/ordertambahan" element={<OrderTambahan />} />
              </Route>
              {/* oke */}

              {/* Redirect any unknown routes to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </LanguageProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
